import { reduce } from 'lodash/fp';

const method =
  (level) =>
  (...params) =>
    console.log(level, ...params);

const levels = [
  'debug',
  'error',
  'info',
  'trace',
  'warn',
  'fatal',
  'onResponse',
];

const logger = reduce(
  (acc, level) => ({
    ...acc,
    [level]: method(level),
  }),
  {},
)(levels);

export const getLogger = () => logger;

export default logger;
